import { render, staticRenderFns } from "./TemplateCommunitiesDetail.vue?vue&type=template&id=39f7ed96&scoped=true"
import script from "./TemplateCommunitiesDetail.vue?vue&type=script&lang=js"
export * from "./TemplateCommunitiesDetail.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TemplateCommunitiesDetail.vue?vue&type=style&index=1&id=39f7ed96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7ed96",
  null
  
)

export default component.exports